import { List, Map } from 'immutable';
import MenuItem, { MenuItems } from 'records/MenuItem';
import BaseList from 'records/BaseList';

import {
  MENU_ITEMS_ASYNC_ACTION_START,
  MENU_ITEMS_ASYNC_ACTION_ERROR,
  MENU_ITEMS_ASYNC_UPDATE_SUCCESS,
  MENU_ITEMS_UPDATE_ACTION_SUCCESS,
  MENU_ITEMS_CATEGORY_UPDATE_ACTION_SUCCESS,
  MENU_ITEMS_CATEGORY_UPDATE,
  MENU_ITEMS_DRAGGABLE_UPDATE,
  MENU_ITEMS_OPTIONS_UPDATE,
  MENU_ITEMS_UPDATE_ORDINALS_SUCCESS,
  MENU_ITEMS_RESET_STATE,
} from 'actions/menuItems';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  options: new Map(),
  data: new List(),
});

const actionsMap = {
  [MENU_ITEMS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEMS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEMS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    let menuItemsData = MenuItems(action.data);
    menuItemsData = MenuItem.sortMenuItemsByOrdinal(menuItemsData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: menuItemsData,
    });
  },
  [MENU_ITEMS_CATEGORY_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const menuItemsData = MenuItems(action.data);
    let newMenuItemsData = MenuItem.mergeMenuItemsById(state.data, menuItemsData);
    newMenuItemsData = MenuItem.sortMenuItemsByOrdinal(newMenuItemsData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuItemsData,
    });
  },
  [MENU_ITEMS_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const newMenuItemsData = MenuItem.sortMenuItemsByOrdinal(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuItemsData,
    });
  },
  [MENU_ITEMS_CATEGORY_UPDATE]: (state, action) => {
    let newMenuItemsData = MenuItem.mergeMenuItemsById(state.data, action.data);
    newMenuItemsData = MenuItem.sortMenuItemsByOrdinal(newMenuItemsData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuItemsData,
    });
  },
  [MENU_ITEMS_DRAGGABLE_UPDATE]: (state, action) => {
    let newMenuItemsData = MenuItem.updateMenuItemOrdinalsFromIndex(action.data);
    newMenuItemsData = MenuItem.sortMenuItemsByOrdinal(newMenuItemsData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuItemsData,
    });
  },
  [MENU_ITEMS_OPTIONS_UPDATE]: (state, action) => {
    return state.merge({
      options: action.options,
    });
  },
  [MENU_ITEMS_UPDATE_ORDINALS_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENU_ITEMS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItems(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
